import { render, staticRenderFns } from "./TheModalMetodo.vue?vue&type=template&id=539915f4&"
import script from "./TheModalMetodo.vue?vue&type=script&lang=js&"
export * from "./TheModalMetodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports